import { Component, OnInit, HostBinding } from '@angular/core';
import { TranslatorService } from '@service/translator/translator.service';
import { LayoutSettingsService } from '@service/layout-settings.service';
import { environment } from '@environments/environment';
import { ConfigsStorage } from '@storage/configs.storage';
import { LocalSettingsKey } from '@shared/types/local-settings';
import { ImageDownloadLogsService } from '@service/utils/image-download-logs.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  script;
  @HostBinding('class.aside-toggled') get asideToggled() {
    return this.layoutSettingsService.getLayoutSetting('asideToggled');
  }
  @HostBinding('class.aside-collapsed') get isCollapsed() {
    return this.layoutSettingsService.getLayoutSetting('isCollapsed');
  }

  constructor(
    public translatorService: TranslatorService,
    public layoutSettingsService: LayoutSettingsService,
    private configsStorage: ConfigsStorage,
    private imageDownloadLogsService: ImageDownloadLogsService
  ) {}

  ngOnInit() {
    this.translatorService.setDefaultLanguage();
    this.script = document.createElement('script');
    this.script.src = this.configsStorage.config.NETMERA_URL || environment.netmera_key;
    this.script.async = true;
    this.script.type = 'text/javascript';
    document.head.appendChild(this.script);
    const activeSessions = JSON.parse(localStorage.getItem(LocalSettingsKey.ACTIVE_SESSIONS));
    Object.keys(activeSessions).forEach(session => {
      this.cleanOldMessagesFromDB(session);
    });
  }

  async cleanOldMessagesFromDB(userLoginEmail: string): Promise<void> {
    const userData = await this.imageDownloadLogsService.getUserData(userLoginEmail);

    const date = new Date();
    const days = +this.configsStorage.config.WEB_REMEMBER_AUTO_DOWNLOAD_DAYS || 30;
    date.setDate(date.getDate() - days);

    // Her email için eski mesajları temizle
    Object.keys(userData).forEach(email => {
      const messages = userData[email];

      // Date filtreleme
      const filteredMessages = messages.filter(msg => {
        const messageDate = new Date(msg.date);
        return messageDate >= date;
      });

      if (filteredMessages.length > 0) {
        userData[email] = filteredMessages;
      } else {
        delete userData[email]; // Eğer hiç mesaj kalmazsa email key’ini sil
      }
    });

    await this.imageDownloadLogsService.setTable(userLoginEmail, userData);
  }
}
